<script setup lang="ts">
	import { cn } from '@/helpers/cn'

	interface Props {
		class?: string
	}

	const props = defineProps<Props>()
</script>

<template>
	<td :class="cn('p-4 font-inter text-sm', props.class)">
		<slot />
	</td>
</template>
